/**
 * CONNECTED SYSTEMS (ADR-0024 T3.2): a client's books in another system, read with a key the firm gives once.
 * The key goes in on connecting and never comes back out: a connection shows only the key's last characters.
 */
import { z } from "zod";
import { Uuid } from "./primitives.js";
import { Tone } from "./vocabulary.js";
export const ConnectionStatus = z.enum(["ACTIVE", "SUSPENDED", "REVOKED"]);
/** A kind of evidence, with the words a person reads for it (served: the browser holds no vocabulary). */
export const EvidenceKindLabel = z.object({ kind: z.string(), label: z.string() });
export const ConnectionSummary = z.object({
    id: Uuid,
    providerKey: z.string(),
    /** The system, in a person's words ("Trabalance"). */
    systemName: z.string(),
    /** The account on the other side, as that system names it. */
    accountName: z.string(),
    /** What the client consented to Leveri reading through it. */
    evidenceKinds: z.array(z.string()),
    evidence: z.array(EvidenceKindLabel),
    status: ConnectionStatus,
    /** The status in a person's words, and its tone: served, never decided in the browser. */
    statusLabel: z.string(),
    tone: Tone,
    /** The last characters of the key, so a person can tell keys apart. Never the key. */
    keyHint: z.string().nullable(),
    establishedAt: z.string(),
});
export const ConnectableSystem = z.object({ providerKey: z.string(), displayName: z.string(), evidenceKinds: z.array(z.string()), evidence: z.array(EvidenceKindLabel) });
export const ConnectionsResponse = z.object({
    connections: z.array(ConnectionSummary),
    /** The systems this deployment can connect; empty where it holds no vault for keys. */
    connectable: z.array(ConnectableSystem),
    /** Whether the viewer may connect or revoke (GRANT_AUTHORITY). */
    viewerMayManage: z.boolean(),
});
export const ConnectSystemRequest = z.object({
    providerKey: z.string().trim().min(1).max(32),
    apiKey: z.string().trim().min(8).max(2048),
    /** The evidence the client consents to; absent means everything the system offers. */
    evidenceKinds: z.array(z.string().min(1).max(64)).min(1).max(10).optional(),
});
export const RevokeConnectionRequest = z.object({ reason: z.string().trim().min(1).max(2000) });
export const ConnectionResponse = z.object({ connection: ConnectionSummary });
//# sourceMappingURL=connections.js.map